import {ExperimentalLink} from "../ExperimentalLink";
import classes from "./WidgetCard.module.css";

interface WidgetCardProps {
    title?: string;
    titleUrl?: string | null;
    description?: string;
    children: React.ReactNode;
    onTitleClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export function WidgetCard({
    title,
    titleUrl,
    description,
    children,
    onTitleClick,
}: WidgetCardProps) {
    return (
        <div className={classes.card}>
            {description && (
                <div className={classes.description}>
                    {titleUrl ? (
                        <ExperimentalLink
                            href={titleUrl}
                            onClick={onTitleClick}
                            style={{
                                textDecoration: "underline",
                                color: "inherit",
                            }}
                        >
                            {description}
                        </ExperimentalLink>
                    ) : (
                        description
                    )}
                </div>
            )}
            {children}
        </div>
    );
}
